// extracted by mini-css-extract-plugin
export default {"special":"Special_special__PqQvf","loading":"Special_loading__n9xKT","special_loading":"Special_special_loading__F-6Xh"};